var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteForGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99967 4.99998C10.2888 4.99998 11.333 3.95581 11.333 2.66665C11.333 1.37748 10.2888 0.333313 8.99967 0.333313C7.71051 0.333313 6.66634 1.37748 6.66634 2.66665C6.66634 3.95581 7.71051 4.99998 8.99967 4.99998ZM3.74967 3.83331V2.08331H2.58301V3.83331H0.833008V4.99998H2.58301V6.74998H3.74967V4.99998H5.49967V3.83331H3.74967ZM4.33301 8.49998C4.33301 6.94831 7.44217 6.16665 8.99967 6.16665C10.5572 6.16665 13.6663 6.94831 13.6663 8.49998V9.66665H4.33301V8.49998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteForGroup);
export default __webpack_public_path__ + "static/media/icInviteForGroup.2c873de82f1d8337336fecd08693786a.svg";
export { ForwardRef as ReactComponent };